import * as config from "Config";
import * as constants from "./constants";

export function clearStore(newObject) {
    return {
        type: constants.PAYMENT_METHOD_CLEAR_STORE,
    };
}

export function initListData(params) {
    let url = config.apiUrl + "/api/PaymentMethod";
    if (params.companyId) {
        url += "/Company/" + params.companyId + "/Summury";
    }
    if (params.companyGroupId) {
        url += "/CompanyGroup/" + params.companyGroupId + "/Summury";
    }

    return {
        remote: {
            method: "get",
            url,
        },
        actions: [
            constants.listSummuryLoadStart,
            constants.listSummuryLoadSuccess,
            constants.listSummuryLoadFail,
        ],
    };
}

export function deletePaymentMethod(params) {
    let url = config.apiUrl + "/api/PaymentMethod/" + params.id;
    if (params.companyId) {
        url += "/Company/" + params.companyId;
    }
    if (params.companyGroupId) {
        url += "/CompanyGroup/" + params.companyGroupId;
    }

    return {
        remote: {
            method: "delete",
            url,
        },

        actions: [constants.itemRemoveStart, constants.itemRemoveSuccess, constants.itemRemoveFail],
    };
}

export function saveNewItem(params) {
    let url = config.apiUrl + "/api/PaymentMethod";
    if (params.companyId) {
        url += "/Company/" + params.companyId;
    }
    if (params.companyGroupId) {
        url += "/CompanyGroup/" + params.companyGroupId;
    }

    return {
        remote: {
            method: "post",
            url,
            data: params,
        },
        actions: [constants.itemSaveStart, constants.itemSaveSuccess, constants.itemSaveFail],
    };
}

export function saveItem(params) {
    let url = config.apiUrl + "/api/PaymentMethod/" + params.id;
    if (params.companyId) {
        url += "/Company/" + params.companyId;
    }
    if (params.companyGroupId) {
        url += "/CompanyGroup/" + params.companyGroupId;
    }

    return {
        remote: {
            method: "put",
            url,
            data: params,
        },
        actions: [constants.itemSaveStart, constants.itemSaveSuccess, constants.itemSaveFail],
    };
}

export function getDetailPaymentMethod(params) {
    let url = config.apiUrl + "/api/PaymentMethod/" + params.id;
    if (params.companyId) {
        url += "/Company/" + params.companyId;
    }
    if (params.companyGroupId) {
        url += "/CompanyGroup/" + params.companyGroupId;
    }

    return {
        remote: {
            method: "get",
            url,
        },
        actions: [
            constants.itemLoadStart,
            constants.itemLoadSuccess,
            constants.itemLoadFail,
        ],
    };
}

export function getFinanceSourceList(params) {
    let url = config.apiUrl + "/api/FinanceSource";
    if (params.companyId) {
        url += "/Company/" + params.companyId;
    }
    if (params.companyGroupId) {
        url += "/CompanyGroup/" + params.companyGroupId;
    }

    return {
        remote: {
            method: "get",
            url,
        },
        actions: [
            constants.listFinanceSourseLoadStart,
            constants.listFinanceSourseLoadSuccess,
            constants.listFinanceSourseLoadFail,
        ],
    };
}
export function getExternalPaymentMethodList(params) {
    let url = config.apiUrl + "/api/ExternalPaymentMethod";
    if (params.companyId) {
        url += "/Company/" + params.companyId;
    }
    if (params.companyGroupId) {
        url += "/CompanyGroup/" + params.companyGroupId;
    }

    return {
        remote: {
            method: "get",
            url
        },
        actions: [
            constants.listExternalPaymentMethodLoadStart,
            constants.listExternalPaymentMethodLoadSuccess,
            constants.listExternalPaymentMethodLoadFail,
        ],
    };
}
